// @generated by protoc-gen-es v1.10.0 with parameter "target=ts"
// @generated from file penumbra/core/component/ibc/v1/ibc.proto (package penumbra.core.component.ibc.v1, syntax proto3)
/* eslint-disable */
// @ts-nocheck
import { Any, Message, proto3, protoInt64 } from "@bufbuild/protobuf";
import { Amount } from "../../../num/v1/num_pb.js";
import { Denom } from "../../../asset/v1/asset_pb.js";
import { Address } from "../../../keys/v1/keys_pb.js";
import { Height } from "../../../../../ibc/core/client/v1/client_pb.js";
/**
 * @generated from message penumbra.core.component.ibc.v1.IbcRelay
 */
export class IbcRelay extends Message {
    /**
     * @generated from field: google.protobuf.Any raw_action = 1;
     */
    rawAction;
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static runtime = proto3;
    static typeName = "penumbra.core.component.ibc.v1.IbcRelay";
    static fields = proto3.util.newFieldList(() => [
        { no: 1, name: "raw_action", kind: "message", T: Any },
    ]);
    static fromBinary(bytes, options) {
        return new IbcRelay().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new IbcRelay().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new IbcRelay().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(IbcRelay, a, b);
    }
}
/**
 * FungibleTokenPacketData defines a struct for the packet payload
 * See FungibleTokenPacketData spec:
 * https://github.com/cosmos/ibc/tree/master/spec/app/ics-020-fungible-token-transfer#data-structures
 *
 * @generated from message penumbra.core.component.ibc.v1.FungibleTokenPacketData
 */
export class FungibleTokenPacketData extends Message {
    /**
     * the token denomination to be transferred
     *
     * @generated from field: string denom = 1;
     */
    denom = "";
    /**
     * the token amount to be transferred
     *
     * @generated from field: string amount = 2;
     */
    amount = "";
    /**
     * the return address
     *
     * @generated from field: string sender = 3;
     */
    sender = "";
    /**
     * the recipient address on the destination chain
     *
     * @generated from field: string receiver = 4;
     */
    receiver = "";
    /**
     * optional memo
     *
     * @generated from field: string memo = 5;
     */
    memo = "";
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static runtime = proto3;
    static typeName = "penumbra.core.component.ibc.v1.FungibleTokenPacketData";
    static fields = proto3.util.newFieldList(() => [
        { no: 1, name: "denom", kind: "scalar", T: 9 /* ScalarType.STRING */ },
        { no: 2, name: "amount", kind: "scalar", T: 9 /* ScalarType.STRING */ },
        { no: 3, name: "sender", kind: "scalar", T: 9 /* ScalarType.STRING */ },
        { no: 4, name: "receiver", kind: "scalar", T: 9 /* ScalarType.STRING */ },
        { no: 5, name: "memo", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    ]);
    static fromBinary(bytes, options) {
        return new FungibleTokenPacketData().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new FungibleTokenPacketData().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new FungibleTokenPacketData().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(FungibleTokenPacketData, a, b);
    }
}
/**
 * A Penumbra transaction action requesting an ICS20 transfer.
 *
 * @generated from message penumbra.core.component.ibc.v1.Ics20Withdrawal
 */
export class Ics20Withdrawal extends Message {
    /**
     * @generated from field: penumbra.core.num.v1.Amount amount = 1;
     */
    amount;
    /**
     * @generated from field: penumbra.core.asset.v1.Denom denom = 2;
     */
    denom;
    /**
     * the address on the destination chain to send the transfer to
     *
     * @generated from field: string destination_chain_address = 3;
     */
    destinationChainAddress = "";
    /**
     * a "sender" penumbra address to use to return funds from this withdrawal.
     * this should be an ephemeral address
     *
     * @generated from field: penumbra.core.keys.v1.Address return_address = 4;
     */
    returnAddress;
    /**
     * The height on the counterparty chain at which this transfer expires, and
     * funds are sent back to the return address.
     *
     * @generated from field: ibc.core.client.v1.Height timeout_height = 5;
     */
    timeoutHeight;
    /**
     * The timestamp, in epoch time, after which this transfer will be considered invalid.
     * Clients must quantize this value to the nearest minute, to preserve privacy.
     * IBC withdrawals that do not quantize timestamps will be rejected.
     *
     * @generated from field: uint64 timeout_time = 6;
     */
    timeoutTime = protoInt64.zero;
    /**
     * The source channel used for the withdrawal
     *
     * @generated from field: string source_channel = 7;
     */
    sourceChannel = "";
    /**
     * Whether to use a "compat" (bech32, non-m) address for the return address in the withdrawal,
     * for compatability with chains that expect to be able to parse the return address as bech32.
     *
     * @generated from field: bool use_compat_address = 8 [deprecated = true];
     * @deprecated
     */
    useCompatAddress = false;
    /**
     * Arbitrary string data to be included in the `memo` field
     * of the ICS-20 FungibleTokenPacketData for this withdrawal.
     * Commonly used for packet forwarding support, or other protocols that may support usage of the memo field.
     *
     * @generated from field: string ics20_memo = 9;
     */
    ics20Memo = "";
    /**
     * Whether to use a transparent address (bech32, 32-byte) for the return address in the withdrawal.
     *
     * @generated from field: bool use_transparent_address = 10;
     */
    useTransparentAddress = false;
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static runtime = proto3;
    static typeName = "penumbra.core.component.ibc.v1.Ics20Withdrawal";
    static fields = proto3.util.newFieldList(() => [
        { no: 1, name: "amount", kind: "message", T: Amount },
        { no: 2, name: "denom", kind: "message", T: Denom },
        { no: 3, name: "destination_chain_address", kind: "scalar", T: 9 /* ScalarType.STRING */ },
        { no: 4, name: "return_address", kind: "message", T: Address },
        { no: 5, name: "timeout_height", kind: "message", T: Height },
        { no: 6, name: "timeout_time", kind: "scalar", T: 4 /* ScalarType.UINT64 */ },
        { no: 7, name: "source_channel", kind: "scalar", T: 9 /* ScalarType.STRING */ },
        { no: 8, name: "use_compat_address", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
        { no: 9, name: "ics20_memo", kind: "scalar", T: 9 /* ScalarType.STRING */ },
        { no: 10, name: "use_transparent_address", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    ]);
    static fromBinary(bytes, options) {
        return new Ics20Withdrawal().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new Ics20Withdrawal().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new Ics20Withdrawal().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(Ics20Withdrawal, a, b);
    }
}
/**
 * @generated from message penumbra.core.component.ibc.v1.ClientData
 */
export class ClientData extends Message {
    /**
     * @generated from field: string client_id = 1;
     */
    clientId = "";
    /**
     * NOTE: left as Any to allow us to add more client types later
     *
     * @generated from field: google.protobuf.Any client_state = 2;
     */
    clientState;
    /**
     * @generated from field: string processed_time = 3;
     */
    processedTime = "";
    /**
     * @generated from field: uint64 processed_height = 4;
     */
    processedHeight = protoInt64.zero;
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static runtime = proto3;
    static typeName = "penumbra.core.component.ibc.v1.ClientData";
    static fields = proto3.util.newFieldList(() => [
        { no: 1, name: "client_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
        { no: 2, name: "client_state", kind: "message", T: Any },
        { no: 3, name: "processed_time", kind: "scalar", T: 9 /* ScalarType.STRING */ },
        { no: 4, name: "processed_height", kind: "scalar", T: 4 /* ScalarType.UINT64 */ },
    ]);
    static fromBinary(bytes, options) {
        return new ClientData().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ClientData().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ClientData().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ClientData, a, b);
    }
}
/**
 * @generated from message penumbra.core.component.ibc.v1.ClientCounter
 */
export class ClientCounter extends Message {
    /**
     * @generated from field: uint64 counter = 1;
     */
    counter = protoInt64.zero;
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static runtime = proto3;
    static typeName = "penumbra.core.component.ibc.v1.ClientCounter";
    static fields = proto3.util.newFieldList(() => [
        { no: 1, name: "counter", kind: "scalar", T: 4 /* ScalarType.UINT64 */ },
    ]);
    static fromBinary(bytes, options) {
        return new ClientCounter().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ClientCounter().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ClientCounter().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ClientCounter, a, b);
    }
}
/**
 * @generated from message penumbra.core.component.ibc.v1.ConsensusState
 */
export class ConsensusState extends Message {
    /**
     * @generated from field: google.protobuf.Any consensus_state = 1;
     */
    consensusState;
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static runtime = proto3;
    static typeName = "penumbra.core.component.ibc.v1.ConsensusState";
    static fields = proto3.util.newFieldList(() => [
        { no: 1, name: "consensus_state", kind: "message", T: Any },
    ]);
    static fromBinary(bytes, options) {
        return new ConsensusState().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ConsensusState().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ConsensusState().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ConsensusState, a, b);
    }
}
/**
 * @generated from message penumbra.core.component.ibc.v1.VerifiedHeights
 */
export class VerifiedHeights extends Message {
    /**
     * @generated from field: repeated ibc.core.client.v1.Height heights = 1;
     */
    heights = [];
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static runtime = proto3;
    static typeName = "penumbra.core.component.ibc.v1.VerifiedHeights";
    static fields = proto3.util.newFieldList(() => [
        { no: 1, name: "heights", kind: "message", T: Height, repeated: true },
    ]);
    static fromBinary(bytes, options) {
        return new VerifiedHeights().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new VerifiedHeights().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new VerifiedHeights().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(VerifiedHeights, a, b);
    }
}
/**
 * @generated from message penumbra.core.component.ibc.v1.ConnectionCounter
 */
export class ConnectionCounter extends Message {
    /**
     * @generated from field: uint64 counter = 1;
     */
    counter = protoInt64.zero;
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static runtime = proto3;
    static typeName = "penumbra.core.component.ibc.v1.ConnectionCounter";
    static fields = proto3.util.newFieldList(() => [
        { no: 1, name: "counter", kind: "scalar", T: 4 /* ScalarType.UINT64 */ },
    ]);
    static fromBinary(bytes, options) {
        return new ConnectionCounter().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ConnectionCounter().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ConnectionCounter().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ConnectionCounter, a, b);
    }
}
/**
 * @generated from message penumbra.core.component.ibc.v1.ClientConnections
 */
export class ClientConnections extends Message {
    /**
     * @generated from field: repeated string connections = 1;
     */
    connections = [];
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static runtime = proto3;
    static typeName = "penumbra.core.component.ibc.v1.ClientConnections";
    static fields = proto3.util.newFieldList(() => [
        { no: 1, name: "connections", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
    ]);
    static fromBinary(bytes, options) {
        return new ClientConnections().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ClientConnections().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ClientConnections().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ClientConnections, a, b);
    }
}
/**
 * IBC configuration data.
 *
 * @generated from message penumbra.core.component.ibc.v1.IbcParameters
 */
export class IbcParameters extends Message {
    /**
     * Whether IBC (forming connections, processing IBC packets) is enabled.
     *
     * @generated from field: bool ibc_enabled = 1;
     */
    ibcEnabled = false;
    /**
     * Whether inbound ICS-20 transfers are enabled
     *
     * @generated from field: bool inbound_ics20_transfers_enabled = 2;
     */
    inboundIcs20TransfersEnabled = false;
    /**
     * Whether outbound ICS-20 transfers are enabled
     *
     * @generated from field: bool outbound_ics20_transfers_enabled = 3;
     */
    outboundIcs20TransfersEnabled = false;
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static runtime = proto3;
    static typeName = "penumbra.core.component.ibc.v1.IbcParameters";
    static fields = proto3.util.newFieldList(() => [
        { no: 1, name: "ibc_enabled", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
        { no: 2, name: "inbound_ics20_transfers_enabled", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
        { no: 3, name: "outbound_ics20_transfers_enabled", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    ]);
    static fromBinary(bytes, options) {
        return new IbcParameters().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new IbcParameters().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new IbcParameters().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(IbcParameters, a, b);
    }
}
/**
 * IBC genesis state.
 *
 * @generated from message penumbra.core.component.ibc.v1.GenesisContent
 */
export class GenesisContent extends Message {
    /**
     * IBC parameters.
     *
     * @generated from field: penumbra.core.component.ibc.v1.IbcParameters ibc_params = 1;
     */
    ibcParams;
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static runtime = proto3;
    static typeName = "penumbra.core.component.ibc.v1.GenesisContent";
    static fields = proto3.util.newFieldList(() => [
        { no: 1, name: "ibc_params", kind: "message", T: IbcParameters },
    ]);
    static fromBinary(bytes, options) {
        return new GenesisContent().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GenesisContent().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GenesisContent().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(GenesisContent, a, b);
    }
}
